import { StyleSheet } from "@-/com.npmjs.react-native";
import { Text } from "@-/com.npmjs.react-native/text";
import {
  getLeaderOpenTrace,
  subscribeLeaderOpenTrace,
} from "@-/dev.improve.haniverse.lib.database.engine";
import { useActorDatabaseFailure } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useSyncExternalStore } from "react";

function getServerLeaderOpenTrace(): string {
  return "";
}

/** The latched actor open failure and its cause chain, e.g. a migration watchdog timeout. */
function describeActorDatabaseFailure(failure: unknown): string {
  const parts: string[] = [];
  let current = failure;
  for (let depth = 0; depth < 4 && current instanceof Error; depth += 1) {
    parts.push(`${current.name}: ${current.message}`);
    current = current.cause;
  }
  return parts.length === 0 ? "none" : parts.join(" <- ");
}

/**
 * Invisible, release-safe publisher of this tab's leader-proxy open breadcrumbs (see
 * `leader-open-trace.ts`) as an `actor-open-diag …` accessibility node. Rendered beside the
 * `SyncStatusSentinel` so a web hierarchy dump of a stuck "Syncing data from cloud..." screen
 * shows whether the worker's open failed, and why — and whether the actor open is latched failed.
 */
export function WebActorOpenDiagnostics() {
  const trace = useSyncExternalStore(
    subscribeLeaderOpenTrace,
    getLeaderOpenTrace,
    getServerLeaderOpenTrace,
  );
  // A latched failed open keeps every study screen in its "study data unavailable" state for the
  // rest of the page's life, so name it here too.
  const failure = useActorDatabaseFailure();
  const label = `actor-open-diag db-failure=${describeActorDatabaseFailure(failure)} trace=${trace === "" ? "none" : trace}`;
  return (
    <Text
      accessibilityLabel={label}
      accessible
      importantForAccessibility="yes"
      pointerEvents="none"
      style={styles.diagnostics}
    >
      {label}
    </Text>
  );
}

// Same invisible-but-laid-out treatment as `SyncStatusSentinel`'s nodes, pinned to the TOP edge so
// it never overlaps them.
const styles = StyleSheet.create({
  diagnostics: {
    color: "transparent",
    fontSize: 6,
    left: 0,
    position: "absolute",
    top: 0,
  },
});
